module.exports = __webpack_public_path__ + "static/img/MQ.97d20eba.png";